import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  ViewChild,
} from "@angular/core";

import * as _ from "lodash";
import { IAngularMyDpOptions, IMyDateModel } from "angular-mydatepicker";

import { FiltersService } from "../../services";
@Component({
  selector: "app-filter",
  templateUrl: "./filter.component.html",
  styleUrls: ["./filter.component.scss"],
})
export class FilterComponent implements OnInit {
  @Input() textBtnNew = "";
  @Input() urlBtnNew = "";
  @Input() typeComponent;

  @Output() expFilter = new EventEmitter();

  @ViewChild("autocompleteFilter") autocompleteFilter;

  placeHolder = "Nome do filtro";
  notFoundText = "Sem resultados";
  searchKeywordFilter = "dsFiltro";
  autocompleteDataFilter;

  textBtnFilter = "Filtrar";

  textLineFilter = "ABRIR FILTROS";

  otherFilters = false;
  colapseLine = false;

  saveFilterBtn = false;
  saveFilterValue;

  filtername = "";

  filterMenu = false;

  filtersText = [];

  filters = {
    vlInicio: 0,
    vlFinal: 0,
    search: "",
    cdProduto: "",
    cdTpServico: "",
    cdFornecedor: "",
    cdRegiao: "",
    cdStatusRequisicao: "",
    cdFilial: "",
    idFsRequisicao: "",
    cdOrdemDeServico: "",
    cdLogomarca: "",
  };

  de = 0;
  ate = 0;

  lastValues;

  search = "";
  equipments = "";
  services = "";
  providers = "";
  regions = "";
  stores = "";
  orders = "";
  status = "";
  serviceorders = "";
  flags = "";

  dayLabelsString = {
    su: "Dom",
    mo: "Seg",
    tu: "Ter",
    we: "Qua",
    th: "Qui",
    fr: "Sex",
    sa: "Sáb",
  };
  monthLabelsString = {
    1: "Jan",
    2: "Fev",
    3: "Mar",
    4: "Abr",
    5: "Mai",
    6: "Jun",
    7: "Jul",
    8: "Ago",
    9: "Set",
    10: "Out",
    11: "Nov",
    12: "Dez",
  };

  datePickerOptions: IAngularMyDpOptions = {
    dateFormat: "dd/mm/yyyy",
    showSelectorArrow: false,
    selectorWidth: "220px",
    selectorHeight: "200px",
    firstDayOfWeek: "su",
    dayLabels: this.dayLabelsString,
    monthLabels: this.monthLabelsString,
  };

  dateFirstDefault = new Date();

  dateFirst = {
    isRange: false,
    singleDate: {
      date: {
        year: this.dateFirstDefault.getFullYear(),
        month: this.dateFirstDefault.getMonth(),
        day: this.dateFirstDefault.getDate(),
      },
    },
  };

  dateLastDefault = new Date();

  dateLast = {
    isRange: false,
    singleDate: {
      date: {
        year: this.dateLastDefault.getFullYear(),
        month: this.dateLastDefault.getMonth() + 1,
        day: this.dateLastDefault.getDate(),
      },
    },
  };

  equipmentsArr;
  servicesArr;
  providersArr;
  regionsArr;
  statusArr;
  flagsArr;

  constructor(private filtersService: FiltersService) {}

  ngOnInit() {
    if (this.typeComponent == "service-providers") {
      this.filtersService.listRegionsStates().subscribe((response) => {
        this.regionsArr = response["data"];
      });

      this.filtersService.listTypesServices().subscribe((response) => {
        this.servicesArr = response["data"];
      });
    }

    if (this.typeComponent == "services") {
      this.filtersService.listTypesServices().subscribe((response) => {
        this.servicesArr = response["data"];
      });

      this.filtersService.listEquipments().subscribe((response) => {
        this.equipmentsArr = response["data"];
      });

      this.filtersService.listProviders().subscribe((response) => {
        this.providersArr = response["data"];
      });
    }

    if (this.typeComponent == "service-order") {
      this.filtersService.listStatus().subscribe((response) => {
        this.statusArr = response["data"];
      });
    }

    if (this.typeComponent == "reports") {
      this.filtersService.listFlags().subscribe((response) => {
        this.flagsArr = response["data"];
      });

      this.filtersService.listRegionsStates().subscribe((response) => {
        this.regionsArr = response["data"];
      });

      this.filtersService.listEquipments().subscribe((response) => {
        this.equipmentsArr = response["data"];
      });

      this.filtersService.listProviders().subscribe((response) => {
        this.providersArr = response["data"];
      });

      this.filtersService.listStatus().subscribe((response) => {
        this.statusArr = response["data"];
      });

      this.autocompleteDataFilter = [
        {
          dsFiltro: "Filtro Salvo",
          ctFiltro: {
            vlInicio: 0,
            vlFinal: 0,
            search: "",
            cdProduto: "1",
            cdTpServico: "",
            cdFornecedor: "28733",
            cdRegiao: "1",
            cdStatusRequisicao: "0",
            cdFilial: "",
            idFsRequisicao: "",
            cdOrdemDeServico: "",
            cdLogomarca: "1",
          },
        },
        {
          dsFiltro: "Outro Filtro",
          ctFiltro: { ...this.filters },
        },
        {
          dsFiltro: "Mais Um Filtro",
          ctFiltro: { ...this.filters },
        },
      ];
    }
  }

  openFilterMenu(bol) {
    if (!bol) {
      this.filterMenu = bol;
    } else {
      this.filterMenu = !this.filterMenu;
    }
  }

  addFilterValues(val) {
    this.removeFilter(this.lastValues);

    this.filtersText.push({
      string: val,
      type: ["vlInicio", "vlFinal"],
    });

    this.lastValues = val;

    this.filters.vlInicio = this.de;

    this.filters.vlFinal = this.ate;

    this.resetValues();

    this.exportFilter();

    this.filterMenu = false;
  }

  addFilterStrings() {
    //equipments
    if (this.equipments != "") {
      if (this.filters.cdProduto) {
        this.removeFilter(
          _.filter(this.equipmentsArr, [
            "cdProduto",
            Number(this.filters.cdProduto),
          ])[0].dsProduto
        );
      }

      this.filtersText.push({
        string: _.filter(this.equipmentsArr, [
          "cdProduto",
          Number(this.equipments),
        ])[0].dsProduto,
        type: "equipments",
      });

      this.filters.cdProduto = this.equipments;
    } else {
      if (this.filters.cdProduto) {
        this.removeFilter(
          _.filter(this.equipmentsArr, [
            "cdProduto",
            Number(this.filters.cdProduto),
          ])[0].dsProduto
        );
      }

      this.filters.cdProduto = "";
    }

    //regions
    if (this.regions != "") {
      if (this.filters.cdRegiao) {
        this.removeFilter(
          _.filter(this.regionsArr, [
            "cdRegiao",
            Number(this.filters.cdRegiao),
          ])[0].dsRegiao
        );
      }

      this.filtersText.push({
        string: _.filter(this.regionsArr, ["cdRegiao", Number(this.regions)])[0]
          .dsRegiao,
        type: "regions",
      });

      this.filters.cdRegiao = this.regions;
    } else {
      if (this.filters.cdRegiao) {
        this.removeFilter(
          _.filter(this.regionsArr, [
            "cdRegiao",
            Number(this.filters.cdRegiao),
          ])[0].dsRegiao
        );
      }

      this.filters.cdRegiao = "";
    }

    //services
    if (this.services != "") {
      if (this.filters.cdTpServico) {
        this.removeFilter(
          _.filter(this.servicesArr, [
            "cdTpServico",
            Number(this.filters.cdTpServico),
          ])[0].dsTpServico
        );
      }

      this.filtersText.push({
        string: _.filter(this.servicesArr, [
          "cdTpServico",
          Number(this.services),
        ])[0].dsTpServico,
        type: "services",
      });

      this.filters.cdTpServico = this.services;
    } else {
      if (this.filters.cdTpServico) {
        this.removeFilter(
          _.filter(this.servicesArr, [
            "cdTpServico",
            Number(this.filters.cdTpServico),
          ])[0].dsTpServico
        );
      }

      this.filters.cdTpServico = "";
    }

    //providers
    if (this.providers != "") {
      if (this.filters.cdFornecedor) {
        this.removeFilter(
          _.filter(this.providersArr, [
            "cdFornecedor",
            Number(this.filters.cdFornecedor),
          ])[0].nmRazaoSocial
        );
      }

      this.filtersText.push({
        string: _.filter(this.providersArr, [
          "cdFornecedor",
          Number(this.providers),
        ])[0].nmRazaoSocial,
        type: "providers",
      });

      this.filters.cdFornecedor = this.providers;
    } else {
      if (this.filters.cdFornecedor) {
        this.removeFilter(
          _.filter(this.providersArr, [
            "cdFornecedor",
            Number(this.filters.cdFornecedor),
          ])[0].nmRazaoSocial
        );
      }

      this.filters.cdFornecedor = "";
    }

    //status
    if (this.status != "") {
      if (this.filters.cdStatusRequisicao) {
        this.removeFilter(
          _.filter(this.statusArr, [
            "cdStatusRequisicao",
            Number(this.filters.cdStatusRequisicao),
          ])[0].dsStatusRequisicao
        );
      }

      this.filtersText.push({
        string: _.filter(this.statusArr, [
          "cdStatusRequisicao",
          Number(this.status),
        ])[0].dsStatusRequisicao,
        type: "status",
      });

      this.filters.cdStatusRequisicao = this.status;
    } else {
      if (this.filters.cdStatusRequisicao) {
        this.removeFilter(
          _.filter(this.statusArr, [
            "cdStatusRequisicao",
            Number(this.filters.cdStatusRequisicao),
          ])[0].dsStatusRequisicao
        );
      }

      this.filters.cdStatusRequisicao = "";
    }

    //stores
    if (this.stores != "") {
      if (this.filters.cdFilial) {
        this.removeFilter(`Nº da Loja: ${this.filters.cdFilial}`);
      }

      this.filtersText.push({
        string: `Nº da Loja: ${this.stores}`,
        type: "stores",
      });

      this.filters.cdFilial = this.stores;
    } else {
      if (this.filters.cdFilial) {
        this.removeFilter(`Nº da Loja: ${this.filters.cdFilial}`);
      }

      this.filters.cdFilial = "";
    }

    //orders
    if (this.orders != "") {
      if (this.filters.idFsRequisicao) {
        this.removeFilter(`Nº do pedido: ${this.filters.idFsRequisicao}`);
      }

      this.filtersText.push({
        string: `Nº do pedido: ${this.orders}`,
        type: "orders",
      });

      this.filters.idFsRequisicao = this.orders;
    } else {
      if (this.filters.idFsRequisicao) {
        this.removeFilter(`Nº do pedido: ${this.filters.idFsRequisicao}`);
      }

      this.filters.idFsRequisicao = "";
    }

    //serviceorders
    if (this.serviceorders != "") {
      if (this.filters.cdOrdemDeServico) {
        this.removeFilter(`ID DA OS: ${this.filters.cdOrdemDeServico}`);
      }

      this.filtersText.push({
        string: `ID DA OS: ${this.serviceorders}`,
        type: "serviceorders",
      });

      this.filters.cdOrdemDeServico = this.serviceorders;
    } else {
      if (this.filters.cdOrdemDeServico) {
        this.removeFilter(`ID DA OS: ${this.filters.cdOrdemDeServico}`);
      }

      this.filters.cdOrdemDeServico = "";
    }

    //flags
    if (this.flags != "") {
      if (this.filters.cdLogomarca) {
        this.removeFilter(
          _.filter(this.flagsArr, [
            "cdLogomarca",
            Number(this.filters.cdLogomarca),
          ])[0].dsLogomarca
        );
      }

      this.filtersText.push({
        string: _.filter(this.flagsArr, ["cdLogomarca", Number(this.flags)])[0]
          .dsLogomarca,
        type: "flags",
      });

      this.filters.cdLogomarca = this.flags;
    } else {
      if (this.filters.cdLogomarca) {
        this.removeFilter(
          _.filter(this.flagsArr, [
            "cdLogomarca",
            Number(this.filters.cdLogomarca),
          ])[0].dsLogomarca
        );
      }

      this.filters.cdLogomarca = "";
    }

    this.exportFilter();

    this.filterMenu = false;
  }

  addFilterSearch() {
    this.removeFilter(this.filters.search);

    if (this.search) {
      this.filtersText.push({
        string: this.search,
        type: "search",
      });
    }

    this.filters.search = this.search;

    this.exportFilter();
  }

  resetValues(reset?) {
    this.de = 0;
    this.ate = 0;

    if (reset) {
      this.filters.vlInicio = 0;
      this.filters.vlFinal = 0;
    }

    this.exportFilter();
  }

  resetFilters() {
    this.filtersText = [];

    this.filters = {
      vlInicio: 0,
      vlFinal: 0,
      search: "",
      cdProduto: "",
      cdTpServico: "",
      cdFornecedor: "",
      cdRegiao: "",
      cdStatusRequisicao: "",
      cdFilial: "",
      idFsRequisicao: "",
      cdOrdemDeServico: "",
      cdLogomarca: "",
    };

    this.de = 0;
    this.ate = 0;
    this.search = "";
    this.equipments = "";
    this.services = "";
    this.providers = "";
    this.regions = "";
    this.stores = "";
    this.orders = "";
    this.status = "";
    this.serviceorders = "";
    this.flags = "";

    this.exportFilter();
  }

  removeFilter(val, type?) {
    _.remove(this.filtersText, function (txt) {
      return txt.string == val;
    });

    if (type) {
      if (_.startsWith(val, "De:")) {
        this.resetValues(true);
      }

      if (typeof type === "object") {
        for (let i = 0; i < type.length; i++) {
          this.filters[type[i]] = 0;
        }
      } else {
        this.filters[type] = "";

        if (type == "search") {
          this.search = "";
        }
      }
    }

    this.exportFilter();
  }

  exportFilter() {
    this.expFilter.emit(this.filters);
  }

  showSaveFilterBtn(event) {
    if (event.length == 0) {
      this.saveFilterBtn = false;
    } else {
      this.saveFilterBtn = true;
    }

    this.saveFilterValue = event;
  }

  saveFilter() {
    let filterForSave = {
      dsFiltro: this.saveFilterValue,
      ctFiltro: { ...this.filters },
    };

    console.log(filterForSave);
  }

  onSelectFilter(event) {
    this.saveFilterBtn = false;

    this.orders = event.ctFiltro.idFsRequisicao;
    this.serviceorders = event.ctFiltro.cdOrdemDeServico;
    this.stores = event.ctFiltro.cdFilial;
    this.flags = event.ctFiltro.cdLogomarca;
    this.regions = event.ctFiltro.cdRegiao;
    this.providers = event.ctFiltro.cdFornecedor;
    this.equipments = event.ctFiltro.cdProduto;
    this.status = event.ctFiltro.cdStatusRequisicao;

    this.autocompleteFilter.query = "";
  }

  toggleOtherFilters() {
    this.otherFilters = !this.otherFilters;

    this.colapseLine = !this.colapseLine;

    if (this.otherFilters) {
      this.textLineFilter = "FECHAR FILTROS";
    } else {
      this.textLineFilter = "ABRIR FILTROS";
    }
  }

  dateFirstChanged(event: IMyDateModel) {
    console.log(event);
  }

  dateLastChanged(event: IMyDateModel) {
    console.log(event);
  }
}
